<template>
  <section id="card-text-alignment">
    <b-row>
      <b-col>
        <b-button
            variant="gradient-primary"
            :to="{ name: 'dashboard-ptc'}"
        >
          <feather-icon
              icon="ArrowLeftIcon"
              class="mr-50"
          />
          <span class="align-middle">Voltar</span>
        </b-button>
      </b-col>
    </b-row>
    <h5 class="mt-2 mb-0">
      Dados do Representante
    </h5>
    <b-row>
      <b-col>
        <b-card class="position-static mt-2 mb-2">
          <div class="stepper-wrapper">
            <div :class="['stepper-item',  currentStep >= 1 ? 'completed1' :'', widthProgress]">
              <div class="step-counter">
                <feather-icon :color="colorIcon(1)" size="18" icon="Edit2Icon"/>
              </div>
              <div class="step-name">Em Alteração</div>
            </div>
            <div :class="['stepper-item',  currentStep >= 2 ? 'completed2' :'']">
              <div class="step-counter">
                <feather-icon :color="colorIcon(2)" size="18" icon="ClockIcon"/>
              </div>
              <div class="step-name">Em Aprovação</div>
            </div>
            <div :class="['stepper-item',  currentStep >= 3 ? 'completed3' :'']">
              <div class="step-counter">
                <feather-icon :color="colorIcon(3)" size="18" icon="CheckIcon"/>
              </div>
              <div class="step-name">Aprovado/Reprovado</div>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-row cols="12">
      <b-col  class="col-3" >
        <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            :variant="getRequestChanges ? 'success' : 'primary'"
            @click="handleButtonClick"
        >
          {{ getRequestChanges ? 'Enviar para aprovação' : 'Solicitar Alteração' }}
        </b-button>
      </b-col>
      <b-col>
        <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="secondary"
            @click="$store.commit('PTC_CadastroClienteClient/SET_REQUEST_CHANGES', false)"
            :hidden="getRequestChanges === false ? true : false"
        >
          Cancelar Alteração
        </b-button>
      </b-col>
    </b-row>
    <h5 class="mt-2 mb-0">
      Dados do Cliente
    </h5>
    <b-overlay
        :show="$store.getters['PTC_CadastroClienteClient/getIsLoading']"
    >
      <b-row>
        <b-col>
          <b-card
              title="Lista de Usuários Cadastrados"
              class="position-static mt-2 mb-2"
          >
            <b-row>
              <b-col md="6">
                <b-form-group
                    label="REPRESENTANTE"
                    label-for="mc-representante"
                >
                  <b-form-input
                      id="mc-representante"
                      placeholder="Representante"
                      v-model="form.representante"
                      :state="form.representante !== null || form.representante !== '' ? true : false"
                      disabled
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                    label="RAMO ATIVIDADE"
                    label-for="mc-ramo-atividade"
                >
                  <b-form-select
                      id="mc-ramo-atividade"
                      v-model="form.ramo_atividade"
                      :options="options"
                      :state="form.ramo_atividade === 'Ramo Atividade' ? false : true"
                      :disabled="$store.getters['PTC_CadastroClienteClient/getRequestChanges'] === false? true : false"
                  />
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                    label="TIPO DE PESSOA"
                    label-for="mc-tipo-pessoa"
                >
                  <b-form-select
                      id="mc-tipo-pessoa"
                      v-model="form.tipo_pessoa"
                      :options="options_cnpj"
                      :state="form.tipo_pessoa === 'Tipo Pessoa' ? false : true"
                      disabled
                  />
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                    label="CNPJ"
                    label-for="mc-cnpj"
                >
                  <b-form-input
                      id="mc-cnpj"
                      placeholder="CNPJ"
                      v-model="form.cnpj"
                      :state="form.cnpj !== null || form.cnpj !== '' ? true : false"
                      disabled
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                    label="RAZÃO SOCIAL"
                    label-for="mc-razao-social"
                >
                  <div class="form-label-group">
                    <b-form-input
                        id="mc-razao-social"
                        placeholder="Razão Social"
                        v-model="form.razao_social"
                        :state="form.razao_social !== null || form.razao_social !== '' ? true : false"
                        :disabled="$store.getters['PTC_CadastroClienteClient/getRequestChanges'] === false? true : false"
                    />
                  </div>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                    label-for="mc-nome-fantasia"
                    label="NOME FANTASIA"
                >
                  <div class="form-label-group">
                    <b-form-input
                        id="mc-nome-fantasia"
                        type="text"
                        placeholder="Nome Fantasia"
                        v-model="form.nome_fantasia"
                        :state="form.nome_fantasia !== null || form.nome_fantasia !== '' ? true : false"
                        :disabled="$store.getters['PTC_CadastroClienteClient/getRequestChanges'] === false? true : false"
                    />
                  </div>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                    label="INSC. ESTADUAL"
                    label-for="mc-inscricao-estadual"
                >
                  <b-row>
                    <b-col md="2">
                      <b-form-checkbox
                          name="check-button"
                          v-model="form.insento"
                          switch
                          inline
                          :state="form.insento"
                          :disabled="$store.getters['PTC_CadastroClienteClient/getRequestChanges']"
                      >
                        ISENTO
                      </b-form-checkbox>
                    </b-col>
                    <b-col md="4">
                      <b-form-input
                          id="mc-inscricao-estadual"
                          placeholder="Inscrição Estadual"
                          v-model="form.inscricao_estadual"
                          :state="form.inscricao_estadual !== null || form.inscricao_estadual !== '' ? true : false"
                          :disabled="$store.getters['PTC_CadastroClienteClient/getRequestChanges'] === false? true : false"
                      />
                    </b-col>
                    <b-col md="3">
                      <b-form-checkbox
                          checked="true"
                          name="check-button"
                          switch
                          inline
                          v-model="form.fat_parcial"
                          :state="form.fat_parcial"
                          :disabled="$store.getters['PTC_CadastroClienteClient/getRequestChanges'] === false? true : false"
                      >
                        FAT. PARCIAL
                      </b-form-checkbox>
                    </b-col>
                  </b-row>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                    label="INSC. MUNICIPAL"
                    label-for="mc-inscricao-municipal"
                >
                  <div class="form-label-group">
                    <b-form-input
                        id="mc-inscricao-municipal"
                        type="text"
                        placeholder="Inscrição Municipal"
                        v-model="form.inscricao_municipal"
                        :state="form.inscricao_municipal !== null || form.inscricao_municipal !== '' ? true : false"
                        :disabled="$store.getters['PTC_CadastroClienteClient/getRequestChanges'] === false? true : false"
                    />
                  </div>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                    label="CÓDIGO SUFRAMA"
                    label-for="mc-codigo-suframa"
                >
                  <div class="form-label-group">
                    <b-form-input
                        id="mc-codigo-suframa"
                        type="text"
                        placeholder="Código Suframa"
                        v-model="form.codigo_suframa"
                        :state="form.codigo_suframa !== null || form.codigo_suframa !== '' ? true : false"
                        :disabled="$store.getters['PTC_CadastroClienteClient/getRequestChanges'] === false? true : false"
                    />
                  </div>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                    label="E-MAIL NFE"
                    label-for="mc-email-nfe"
                >
                  <div class="form-label-group">
                    <b-form-input
                        id="mc-email-nfe"
                        type="text"
                        placeholder="E-mail NFE"
                        v-model="form.email_nfe"
                        :state="form.email_nfe !== null || form.email_nfe !== '' ? true : false"
                        :disabled="$store.getters['PTC_CadastroClienteClient/getRequestChanges'] === false? true : false"
                    />
                  </div>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                    label="E-MAIL COMERCIAL"
                    label-for="mc-email-comercial"
                >
                  <div class="form-label-group">
                    <b-form-input
                        id="mc-email-comercial"
                        type="text"
                        placeholder="E-mail Comercial"
                        v-model="form.email_comercial"
                        :state="form.email_comercial !== null || form.email_comercial !== '' ? true : false"
                        :disabled="$store.getters['PTC_CadastroClienteClient/getRequestChanges'] === false? true : false"
                    />
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </b-overlay>
    <h5 class="mt-2 mb-0">
      Endereço
    </h5>
    <b-row>
      <b-col>
        <b-card
            title="Endereço"
            class="position-static mt-2 mb-2"
        >
          <endereco />
        </b-card>
      </b-col>
    </b-row>
    <h5 class="mt-2 mb-0">
      Contato
    </h5>
    <b-row>
      <b-col>
        <b-card
            title="Contatos"
            class="position-static mt-2 mb-2"
        >
          <contato/>
        </b-card>
      </b-col>
    </b-row>
    <h5 class="mt-2 mb-0">
      Documento
    </h5>
    <b-row>
      <b-col>
        <b-card
            title="Documentos"
            class="position-static mt-2 mb-2"
        >
          <documento/>
        </b-card>
      </b-col>
    </b-row>
  </section>
</template>
<script>
import { BFormSelect } from 'bootstrap-vue';
import PTC_CadastroClienteService from '@/services/PTC/PTC_CadastroCliente.service';

import { mapGetters } from 'vuex';
import CadastroClienteModal from '@/views/app/PTC/CadastroCliente/CadastroClienteModal.vue';
import Endereco from '@/views/app/PTC/CadastroCliente/endereco/endereco.vue';
import Contato from '@/views/app/PTC/CadastroCliente/contato/Contato.vue';
import Documento from '@/views/app/PTC/CadastroCliente/documento/documento.vue';
import store from '@/store';

const ptc_cadastro_cliente_service = new PTC_CadastroClienteService();

export default {
  components: {
    Documento,
    Contato,
    Endereco,
    CadastroClienteModal,
    BFormSelect,
  },
  data() {
    return {
      options_cnpj: ['Tipo Pessoa', 'Pessoa Física', 'Jurídica'],
      options: ['Ramo Atividade', 'Indústria', 'Comércio', 'Serviços', 'Ramo-a'],
      form: {
        representante: '',
        ramo_atividade: '',
        tipo_pessoa: '',
        cnpj: '',
        razao_social: '',
        nome_fantasia: '',
        inscricao_estadual: '',
        insento: '',
        fat_parcial: '',
        inscricao_municipal: '',
        codigo_suframa: '',
        email_nfe: '',
        email_comercial: '',
      },
      fields: [
        { key: 'seq', label: 'Seq.' },
        { key: 'tipoEndereco', label: 'Tipo Endereço' },
        { key: 'endereco', label: 'Endereço' },
        { key: 'action', label: 'Ações' },
      ],
      currentStep: 0,
      busy: false,
      timeout: null,
      dynamicWidth: '50%',
      atualizarEndereco: {},
      adicionarEndereco: {},
    };
  },

  methods: {
    async getServiceCliente() {
      await ptc_cadastro_cliente_service.executGet();
    },
    async mountedForm() {
      if (this.getCliente.length > 0) {
        this.form = {
          representante: this.getCliente[0].representanteDescricao,
          ramo_atividade: this.getCliente[0].clienteramoatividade,
          tipo_pessoa: this.getCliente[0].clientetipopessoa,
          cnpj: this.getCliente[0].clientecnpj,
          razao_social: this.getCliente[0].clienterazaosocial,
          nome_fantasia: this.getCliente[0].clientenomefantasia,
          inscricao_estadual: this.getCliente[0].clienteinscricaomunicipal,
          insento: this.getCliente[0].clienteisentoie,
          fat_parcial: this.getCliente[0].clientefaturamentoparcial,
          inscricao_municipal: this.getCliente[0].clienteinscricaomunicipal,
          codigo_suframa: this.getCliente[0].clientecodigosuframa,
          email_nfe: this.getCliente[0].clienteemailnfe,
          email_comercial: this.getCliente[0].clienteemailcomercial,
        };
      }
    },
    abrirModal() {
      // this.$refs.modal.abrirModal()
    },

    handleButtonClick() {
      if (this.getRequestChanges) {
        console.log('Enviando para avaliação...');
        // this.enviarParaAvaliacao();
        this.currentStep = 2;
        this.dynamicWidth = 'dynamic-width-100';
      } else {
        console.log('Solicitando alteração...');
        // this.solicitarAlteracao();
        this.currentStep = 1;
        this.dynamicWidth = 'dynamic-width-50';
      }

      store.commit('PTC_CadastroClienteClient/SET_REQUEST_CHANGES', !this.getRequestChanges);
    },
    async enviarParaAvaliacao() {
      console.log('Enviando para avaliação...');
      store.commit('PTC_CadastroClienteClient/SET_REQUEST_CHANGES', true);
      await this.getServiceCliente();
      await this.mountedForm();
    },
    solicitarAlteracao() {
      console.log('Solicitando alteração...');
      store.commit('PTC_CadastroClienteClient/SET_REQUEST_CHANGES', false);
    },
    colorIcon(step) {
      return this.currentStep >= step ? 'white' : 'grey';
    },

  },
  async mounted() {
    await this.getServiceCliente();
    await this.mountedForm();
  },
  computed: {
    ...mapGetters({
      getCliente: 'PTC_CadastroClienteClient/getCliente',
      getRequestChanges: 'PTC_CadastroClienteClient/getRequestChanges',
    }),
    widthProgress() {
      return this.dynamicWidth;
    },
  },
};
</script>

<style scoped lang="scss">
.stepper-wrapper {
  font-family: Arial;
  margin-top: 50px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.stepper-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;

  @media (max-width: 768px) {
    font-size: 12px;
  }
}

.stepper-item::before {
  position: absolute;
  content: "";
  border-bottom: 2px solid #ccc;
  width: 100%;
  top: 22px;
  left: -50%;
  z-index: 2;
}

.stepper-item::after {
  position: absolute;
  content: "";
  border-bottom: 2px solid #ccc;
  width: 100%;
  top: 20px;
  left: 50%;
  z-index: 2;
}

.stepper-item .step-counter {
  position: relative;
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #ccc;
  margin-bottom: 6px;
}

.stepper-item.active {
  font-weight: bold;
}

.stepper-item.completed1 .step-counter {
  background-color: #42cd81;
}

.stepper-item.completed2 .step-counter {
  background-color: #42cd81;
}

.stepper-item.completed1::after {
  position: absolute;
  content: "";
  width: 0;
  border-bottom: 4px solid #42cd81;
  top: 20px;
  left: 50%;
  z-index: 3;
}

.dynamic-width-50.completed1::after {
  width: 50%;
}

.dynamic-width-100.completed1::after {
  width: 100%;
}

.stepper-item.completed2::after {
  position: absolute;
  content: "";
  border-bottom: 4px solid #42cd81;
  width: 100%;
  top: 20px;
  left: 50%;
  z-index: 3;
}

.stepper-item.completed3::after {
  position: absolute;
  content: "";
  border-bottom: 4px solid #42cd81;
  width: 100%;
  top: 20px;
  left: 50%;
  z-index: 3;
}

.stepper-item:first-child::before {
  content: none;
}

.stepper-item:last-child::after {
  content: none;
}

</style>
